import { Row, Col, Card } from "reactstrap";
import { Progressbar } from "../../../../AbstractElements";
import { LargeProgressBars } from "../../../../Constant";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { LARGE_PROGRESS_DATA, LARGE_PROGRESS_LIST } from "../../../../Data/UiKit/Progress";

export const LargeProgressBarsCart = () => {
  return (
    <Col xl="6">
      <Card className="height-equal">
        <CommonCardHeader title={LargeProgressBars} span={LARGE_PROGRESS_DATA} />
        <Row className="card-body progress-showcase mb-3">
          <Col>
            <Progressbar color="primary" value="25" className="lg-progress-bar">25%</Progressbar>
            {LARGE_PROGRESS_LIST.map(({color,value,text},index)=>(
              <Progressbar color={color} value={value} className="lg-progress-bar" key={index}>{text}</Progressbar>
            ))}
          </Col>
        </Row>
      </Card>
    </Col>
  );
};
